import * as ACTION_TYPES from "../types";

let initialState = {
  bankList: [],
  bank: {},
  bankCommission: {},
  loading: false,
  error: false,
  message: [],
  channelAndBankNames: [],
  bankCommissionProfils: [],
  editingCommissionProfil: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.GET_BANKS:
      return { ...state, bankList: action.data };
    case ACTION_TYPES.GET_BANK_BY_ID:
      return { ...state, bankCommission: action.data };
    case ACTION_TYPES.GET_BANK_NAME_CHANNEL_NO:
      return { ...state, channelAndBankNames: action.data };
    case ACTION_TYPES.GET_BANK_COMMISSION_PROFILS:
      return { ...state, bankCommissionProfils: action.data };
    case ACTION_TYPES.GET_BANK_COMMISSION_PROFIL:
      return { ...state, editingCommissionProfil: action.data };
    default:
      return state;
  }
};
